import React from 'react';
import {
	Select,
	SelectTrigger,
	SelectValue,
	SelectContent,
	SelectItem,
} from '@/components/ui/select';
import { years, days, months } from '@/constants';
import { Label } from '@radix-ui/react-label';
import { useSignUp } from '@/contexts/signup.context.jsx';

const containerBase = 'flex flex-col items-start gap-2 w-full';
const labelBase = 'text-sm font-[400] text-[#B5B6BA]';
const selectBase =
	'w-full bg-[#1E2748] border border-[#506296] text-white text-md font-semibold rounded-full h-10 px-4 focus:outline-none';

export const BirthdateForm = () => {
	const { birthDate, setBirthDate } = useSignUp();

	return (
		<div className="flex flex-col gap-2 text-white w-full mb-5">
			<div className="flex gap-4 w-full">
				<div className={containerBase}>
					<Label className={labelBase}>Month</Label>
					<Select
						value={birthDate.month}
						onValueChange={(value) => value && setBirthDate((prev) => ({ ...prev, month: value }))}
					>
						<SelectTrigger className={selectBase}>
							<SelectValue placeholder="MMM" />
						</SelectTrigger>
						<SelectContent>
							{months.map(({ value, label }) => (
								<SelectItem key={value} value={value}>
									{label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>

				<div className={containerBase}>
					<Label className={labelBase}>Day</Label>
					<Select
						value={birthDate.day}
						onValueChange={(value) => value && setBirthDate((prev) => ({ ...prev, day: value }))}
					>
						<SelectTrigger className={selectBase}>
							<SelectValue placeholder="DD" />
						</SelectTrigger>
						<SelectContent>
							{days.map(({ value, label }) => (
								<SelectItem key={value} value={value}>
									{label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>

				<div className={containerBase}>
					<Label className={labelBase}>Year</Label>
					<Select
						value={birthDate.year}
						onValueChange={(value) => value && setBirthDate((prev) => ({ ...prev, year: value }))}
					>
						<SelectTrigger className={selectBase}>
							<SelectValue placeholder="YYYY" />
						</SelectTrigger>
						<SelectContent>
							{years.map(({ value, label }) => (
								<SelectItem key={value} value={value}>
									{label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
			</div>
		</div>
	);
};
